// BE のエラー応答から表示用メッセージを取り出す。
//
// BE は全エラーで {"status":"error","message":"..."} を返す（views_employee_request.py の _err）。
// これを固定文言に潰すと「直せる原因」が画面から消え、ユーザーは同じ操作を繰り返すことになる。
// 例) 賞与名が51文字 → BEは「賞与名は50文字以内で指定してください」を返すのに
//     画面には「PDFファイルを確認してください。」と出ていた。
//
// 使い方:
//   if (!res.ok) { setError(await apiErrorMessage(res, "申請の送信に失敗しました。")); return; }
export default async function apiErrorMessage(res, fallback) {
  try {
    const d = await res.json();
    if (d && typeof d.message === "string" && d.message.trim()) return d.message;
  } catch (_) {
    // 本文が無い/JSONでない（502・タイムアウト等）→ fallback を使う
  }
  return fallback;
}
